import http from "@/utils/http";

export default {
  login(username, password, rememberMe) {
    return http.post("/api/login/", {
      username,
      password,
      remember_me: rememberMe
    });
  },
  logout() {
    return http.post("/api/logout/", {});
  },
  getUser() {
    return http.get("/api/user/");
  },
  updateUser(data) {
    return http.post(`/api/profile/update/`, data);
  }
};
